import React, { useEffect } from 'react';

import { ManageRules } from './ManageRules';
import { Page } from './Page';
import { usePageTitle } from './PageTitleContext';

export function ManageRulesPage() {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle('Rules');
  }, []);

  return (
    <Page header={null}>
      <ManageRules isModal={false} payeeId={null} />
    </Page>
  );
}
